var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"materials-editor",on:{"click":_vm.handleEditorClick}},[_c('ToolBar'),_c('Sketchpad'),_c('PanelLeft'),_c('PanelRight'),_c('ContextMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }